// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeContestPendingSetupGetBody = {
  poolId: string;
};

export type typeContestPendingSetupGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    setup?: {
      name: string;
      savedAt: string;
      config: {
        startDate: string;
        roundGrouping: "day" | "week";
        weekStartDay?: number | null;
        roundLockTiming?: "firstGame" | "lastGame";
        pickBasis: "moneyline" | "spread";
        spreadTiming?: "lockedEarly" | "live" | null;
        advanceCriterion: "winAll" | "winHalfOrMore";
        livesAllowed?: number;
        requiredPicksPerRound: number;
        maxEntriesPerMember: number;
        teamReuseAllowed: boolean;
        teamReuseLockoutDays?: number | null;
        teamReuseMaxCount?: number | null;
        revivesAllowed: "unlimited" | "limited";
        revivesAllowedCount?: number | null;
        postponementPolicy: "makeUpNextRound" | "countAsLoss";
        tiePolicy: "tieIsWin" | "tieIsLoss";
        tiebreaker: "splitMedal" | "noWinner" | "commissionerPick";
        winPoints: number;
        lossPoints: number;
        skipsAllowed?: boolean;
        skipsMaxPerContest?: number | null;
        endDate?: string | null;
        endDateMode?: "date" | "tbd" | null;
        pickSchedule?: {
          version: 1;
          requirements: {
            requirementId: string;
            startsOn: string;
            endsOn: string | null;
            timeZone: string;
            cadence: "day" | "week";
            weekStartDay: number | null;
            requiredPicks: number;
            revivedRequiredPicks: number | null;
            lockTiming: "firstGame" | "lastGame";
            teamReuseAllowed: boolean;
            inheritPreviousReuse: boolean;
            extendPreviousGames: boolean;
            postponementPolicy: "makeUpNextRound" | "countAsLoss";
          }[];
        } | null;
        spreadPolicy?: "automatic72h";
      };
    } | null;
  };
};

export type typeContestPendingSetupGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestPendingSetupGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeContestPendingSetupGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaContestPendingSetupGetBody = {
  type: "object",
  properties: { poolId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["poolId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createContestPendingSetupGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaContestPendingSetupGetBody);
  }

  return async function postContestPendingSetupGet(
    payload: typeContestPendingSetupGetBody,
  ): Promise<
    typeContestPendingSetupGetOutput200 | typeContestPendingSetupGetOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postContestPendingSetupGet" failed before calling the network. #05dfecc5afb8`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#05dfecc5afb8" },
        },
        data: null,
      } as typeContestPendingSetupGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/contest/pending-setup-get`,
      httpMethod: "POST",
      options,
    })) as
      typeContestPendingSetupGetOutput200 | typeContestPendingSetupGetOutput400;
  };
}
